import type React from 'react';
import { useCallback } from 'react';

import { ACTION_TYPE_SET_SHIP_FROM_LOCATION } from '../../../../settings/automation-rules/constants/action-types';

import { PlaybookCard } from '../../playbook-card/playbook-card';

import type { PreconfiguredRule } from '../automation-playbook-types';
import { AutomationPlaybooks } from '../playbooks';
import { useOpenRuleEditor } from '../use-open-rule-editor';
import { messages } from '../messages';

export const SHIP_FROM_STORE_RULE: PreconfiguredRule = {
  active: true,
  isNew: true,
  isTemplate: true,
  playbook: AutomationPlaybooks.ShipFromByStore,
  ruleName: messages.shipFromStoreRuleName,
  filterConditions: [{ fieldType: 'StoreGuid', operator: 'includes', value: '', logicalOperator: 'AND' }],
  orderRuleActions: [
    {
      actionTypeId: ACTION_TYPE_SET_SHIP_FROM_LOCATION,
      intParameter: null,
      isDeleted: false,
    },
  ],
};

export const ShipFromStoreRuleCard: React.FC = () => {
  const openRuleEditor = useOpenRuleEditor();
  const handleClick = useCallback(() => openRuleEditor(SHIP_FROM_STORE_RULE), [openRuleEditor]);

  return (
    <PlaybookCard
      description={messages.shipFromStoreDescription}
      glyph='storeFront'
      onClick={handleClick}
      title={messages.shipFromStoreTitle}
    />
  );
};
